import React from 'react'

export default () => {
    return (
        <div className="logo-wrapper main-logo">
            Logistics
        </div>
    )
}
